class IntraSerializer {
  static deSerializeItem(item) {
    return {
      order: item.OrdenItem,
      link: item.Link,
      title: item.Titulo,
      titleColor: item.TituloColor,
      description: item.Descripcion,
      descriptionColor: item.DescripcionColor,
    };
  }

  static deSerialize(section) {
    return {
      order: section.Orden,
      icon: section.Icono,
      title: section.Nombre,
      items: (section.ItemHomeIntranetItem || []).map(IntraSerializer.deSerializeItem),
    };
  }
}

export { IntraSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/IntraSerializer.js